export default __webpack_public_path__ + "logo-adigital-negativo.png?d69c5f80";